module.exports = __webpack_public_path__ + "static/media/FormLinkIcon.150193ae.svg";